/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Labs_Converter_SubtitleInputs */

const en_ui_labs_converter_subtitle = /** @type {(inputs: Ui_Labs_Converter_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert between pace, distance, and time`)
};

const de_ui_labs_converter_subtitle = /** @type {(inputs: Ui_Labs_Converter_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umrechnung zwischen Pace, Distanz und Zeit`)
};

/**
* | output |
* | --- |
* | "Convert between pace, distance, and time" |
*
* @param {Ui_Labs_Converter_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_labs_converter_subtitle = /** @type {((inputs?: Ui_Labs_Converter_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Labs_Converter_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_labs_converter_subtitle(inputs)
	return de_ui_labs_converter_subtitle(inputs)
});